"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldFactory = void 0;
const core_api_1 = require("@ikegps/core-api");
const anchor_field_1 = require("./anchor.field");
const date_field_1 = require("./date.field");
const file_tool_field_1 = require("./file.tool.field");
const form_field_1 = require("./form.field");
const height_field_1 = require("./height.field");
const image_field_1 = require("./image.field");
const location_field_1 = require("./location.field");
const nested_list_field_1 = require("./nested.list.field");
const number_field_1 = require("./number.field");
const select_list_field_1 = require("./select.list.field");
const text_field_1 = require("./text.field");
const true_size_field_1 = require("./true.size.field");
const vector_field_1 = require("./vector.field");
const vertical_separation_field_1 = require("./vertical.separation.field");
const yes_no_field_1 = require("./yes.no.field");
exports.FieldFactory = {
    create(parent, schema) {
        switch (schema.type) {
            case core_api_1.IkeFieldType.TEXT:
                return new text_field_1.CollectionModelFieldText(parent, schema);
            case core_api_1.IkeFieldType.NUMBER:
                return new number_field_1.CollectionModelFieldNumber(parent, schema);
            case core_api_1.IkeFieldType.DATE:
                return new date_field_1.CollectionModelFieldDate(parent, schema);
            case core_api_1.IkeFieldType.FORM:
                return new form_field_1.CollectionModelFieldSubForm(parent, schema);
            case core_api_1.IkeFieldType.TRUE_SIZE:
                return new true_size_field_1.CollectionModelFieldTrueSize(parent, schema);
            case core_api_1.IkeFieldType.SELECT_LIST:
                return new select_list_field_1.CollectionModelFieldSelectList(parent, schema);
            case core_api_1.IkeFieldType.NESTED_LIST:
                return new nested_list_field_1.CollectionModelFieldNestedList(parent, schema);
            case core_api_1.IkeFieldType.IMAGE:
                return new image_field_1.CollectionModelFieldImage(parent, schema);
            case core_api_1.IkeFieldType.LOCATION:
                return new location_field_1.CollectionModelFieldLocation(parent, schema);
            case core_api_1.IkeFieldType.VECTOR:
                return new vector_field_1.CollectionModelFieldVector(parent, schema);
            case core_api_1.IkeFieldType.ANCHOR:
                return new anchor_field_1.CollectionModelFieldAnchor(parent, schema);
            case core_api_1.IkeFieldType.HEIGHT:
                return new height_field_1.CollectionModelFieldHeight(parent, schema);
            case core_api_1.IkeFieldType.YES_NO:
                return new yes_no_field_1.CollectionModelFieldYesNo(parent, schema);
            case core_api_1.IkeFieldType.VERTICAL_SEPARATION:
                return new vertical_separation_field_1.CollectionModelFieldVerticalSeparation(parent, schema);
            case core_api_1.IkeFieldType.FILE_TOOL:
                return new file_tool_field_1.CollectionModelFieldFileTool(parent, schema);
            default:
                throw new Error(`Schema "${schema.id}": Unable to find field type:${schema.type}`);
        }
    }
};
//# sourceMappingURL=field.factory.js.map